


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { AfpForm } from '@/models/config'

// Components
import { FormCreateEditAfp } from '@/components/config'

@Component({
    name: 'ModalCreateEditAfp',
    components: {
        FormCreateEditAfp
    }
})
export default class ModalCreateEditAfp extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) afp!: AfpForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva AFP'
        }
        return 'Editar AFP'
    }
}
